export const theme = {
  primaryColor: "#000000",
  secondaryColor: "#00ff00",
  tertiaryColor: "#7a7a7a",
  fontSize: "16px",
  marginLeft: "200px",
};
